import { CartRuleEngine } from 'cart-rule-engine';
import { fetchCart } from 'theme';
class CartThemeConnector {
	constructor() {
		this.cartRuleEngine = new CartRuleEngine({
			rules: window.cartSettings.rules || [],
			successMessage: window.cartSettings.successMessage || '',
		});
		document.addEventListener('cart:change', this.onCartChange.bind(this));
		this.cartDrawer = document.querySelector('cart-drawer');
		this.initCartDrawerEvents();
	}
	initCartDrawerEvents() {
		this.cartDrawer.addEventListener('dialog:before-show', this.setupProgressBarAnimation.bind(this));
		this.cartDrawer.addEventListener('dialog:after-show', this.animateProgressBar.bind(this));
		this.cartDrawer.addEventListener('dialog:after-show', this.setItemsRemovedRulesToDefault.bind(this));
		this.cartDrawer.addEventListener('cart-drawer:refreshed', this.handleProgressBarRefresh.bind(this));
	}
	async setupProgressBarAnimation() {
		await this.updateCartBarProgress();
		this.bar = this.cartDrawer.querySelector('cart-bar');
		this.bar?.setProgressWidth(0);
	}
	animateProgressBar() {
		this.bar = this.cartDrawer.querySelector('cart-bar');
		this.bar?.animateProgressBar(0, this.cartBarProgress);
		this.oldCartBarProgress = this.cartBarProgress;
	}
	handleProgressBarRefresh() {
		this.bar = this.cartDrawer.querySelector('cart-bar');
		if (this.oldCartBarProgress === this.cartBarProgress) {
			this.bar?.setProgressWidth(this.oldCartBarProgress);
			return;
		}
		this.bar?.animateProgressBar(this.oldCartBarProgress, this.cartBarProgress);
		this.oldCartBarProgress = this.cartBarProgress;
	}
	transformPayloads(payload) {
		const updates = {};
		payload.forEach((item) => {
			updates[item.id] = item.quantity;
		});
		return updates;
	}
	updateItemsInCart({ updatePayload }) {
		let sectionsToBundle = [];
		document.documentElement.dispatchEvent(
			new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }),
		);
		const data = {
			updates: updatePayload,
			sections: sectionsToBundle.join(','),
		};
		fetch(`${Shopify.routes.root}cart/update.js`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(data),
		})
			.then(async (response) => {
				if (response.ok) {
					const cartContent = await response.json();
					// document.dispatchEvent(new CustomEvent('cart:refresh'));
					document.documentElement.dispatchEvent(
						new CustomEvent('cart:change', {
							bubbles: true,
							detail: {
								baseEvent: 'line-item:change',
								cart: cartContent,
							},
						}),
					);
				}
			})
			.catch((error) => {
				console.error('Error:', error);
			});
	}
	getRulePositions() {
		return this.cartRuleEngine.getRulePositions();
	}
	async updateValues(cart) {
		const currentCart = cart ? cart : await fetchCart;
		const { qualifiedRules, payloads, formattedText, shippingPrice, cartBarProgress } =
			this.cartRuleEngine.processCartRules(currentCart);
		this.qualifiedRules = qualifiedRules;
		this.payloads = payloads;
		this.formattedText = formattedText;
		this.shippingPrice = shippingPrice;
		this.cartBarProgress = cartBarProgress;
	}
	async getFormattedText() {
		await this.updateValues();
		if (this.formattedText) {
			return this.formattedText;
		}
		return this.formattedText;
	}
	async getQualifiedRules() {
		if (this.qualifiedRules) {
			return this.qualifiedRules;
		}
		await this.updateValues();
		return this.qualifiedRules;
	}
	async updateCartBarProgress() {
		if (this.cartBarProgress) {
			await this.updateValues();
		}
	}
	async onCartChange(event) {
		const cart = event.detail.cart;
		this.updateValues(cart);
		if (!this.payloads || this.payloads.length === 0) {
			return;
		}
		const updatePayload = this.transformPayloads(this.payloads);
		this.updateItemsInCart({
			updatePayload,
		});
	}
	setItemsRemovedRulesToDefault() {
		this.cartRuleEngine?.rules.forEach((rule) => {
			if (rule.itemRemoved) {
				rule.setItemRemovedRule(false);
			}
		});
	}
}
window.themeConnector = new CartThemeConnector();
export { CartThemeConnector };
// TODO DEV CODE REMOVE
// document.querySelector('#cart-drawer').show();
